import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import {
    FacebookIcon,
    FacebookShareButton,
    TwitterIcon,
    TwitterShareButton
} from 'react-share'
import { Challenge } from 'src/services/types/searchEvents'

interface ReferralModalContentProps {
    isLoggedIn: boolean
    referralCode?: string
    event?: Challenge
}

export default function ReferralModalContent({
    isLoggedIn,
    referralCode,
    event
}: ReferralModalContentProps) {
    const BASE_SHARE_URL = 'https://yes.fit/'
    const shareMessage = event?.name
        ? `I just joined ${event.name}! Use my referral code and we both get a discount on our next Yes.Fit purchase!
Referral Code: ${referralCode}`
        : `Use my referral code and we both get a discount on our next Yes.Fit purchase!
Referral Code: ${referralCode}`
    return (
        <div className="bg-white transition-all flex w-full rounded-xl items-center ">
            <div className="mr-1 pt-2 flex flex-col items-center">
                <div className="divide-y-2 divide-gray-200 divide-solid">
                    <div>
                        <div>
                            <Image
                                layout="responsive"
                                src="/money-man.png"
                                alt="jumping man with floating money"
                                width={944}
                                height={736}
                            />
                        </div>
                        <p className="flex justify-center p-4 text-xl sm:text-2xl md:text-3xl font-medium text-yf-green">
                            Give $5, Get $5
                        </p>
                    </div>
                    <p className="text-xs px-4 pt-4 mb-2 md:text-sm lg:text-base text-gray-600 ">
                        Everytime a new friend makes their first purchase at Yes.Fit, you
                        will receive a credit for $5 and your new friend who joined will
                        also get $5 towards their purchase!
                    </p>
                </div>
                {isLoggedIn ? (
                    <>
                        <p className="text-center text-sm md:text-base lg:text-lg text-gray-600 font-medium pt-2 mb-4">
                            Share the code below to earn your reward!
                        </p>
                        <div className="relative flex items-center justify-center">
                            <Image
                                src="/purple-ticket.png"
                                alt="purple-ticket"
                                width={316}
                                height={83}
                            />
                            <p className="absolute text-white font-bold tracking-[0.4rem]">
                                {referralCode.toString()}
                            </p>
                        </div>
                        {/* <button
                            className="my-4 w-full py-4 bg-yf-green text-white font-medium rounded-lg lg:text-xl"
                            disabled={!referralCode}
                        >
                            Share Code
                        </button> */}
                        <div className="flex my-4 py-2 items-center">
                            <div className="mx-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500">
                                <FacebookShareButton
                                    url={`${BASE_SHARE_URL}/${
                                        event && encodeURIComponent(event.challengeUrl)
                                    }`}
                                    quote={shareMessage}
                                    hashtag="#yesfit"
                                >
                                    <FacebookIcon size={40} round={true} />
                                </FacebookShareButton>
                            </div>
                            <div className="mx-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500">
                                <TwitterShareButton
                                    url={`${BASE_SHARE_URL}${
                                        event ? event.challengeUrl : ''
                                    }`}
                                    title={shareMessage}
                                    hashtags={['yesfit', 'yesfitrewards']}
                                    related={['@Yesfit1']}
                                >
                                    <TwitterIcon size={40} round={true} />
                                </TwitterShareButton>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <p className="text-sm md:text-base lg:text-lg text-gray-600 font-medium pt-2 mb-4 text-center">
                            You must be logged in to share a referral code.
                        </p>
                        <div className="relative flex items-center justify-center filter blur-sm">
                            <Image
                                src="/purple-ticket.png"
                                alt="purple-ticket"
                                width={316}
                                height={83}
                            />
                            <p className="absolute filter blur-sm text-white font-bold tracking-[0.7rem]">
                                MMTR123
                            </p>
                        </div>
                        <div className="flex flex-row w-full justify-around">
                            <Link href="/login">
                                <button className="flex-auto my-4 w-[8rem] px-4 py-2 bg-yf-purple text-white text-sm rounded lg:w-[10rem] lg:text-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500">
                                    Sign In
                                </button>
                            </Link>
                            <Link href="/register">
                                <button className="flex-auto my-4 w-[8rem] px-4 py-2 bg-yf-green text-white text-sm rounded lg:w-[10rem] lg:text-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500">
                                    Join for Free
                                </button>
                            </Link>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}
